import React, { useCallback, useContext, useEffect, useState } from "react";
import { Container } from "components";
import Breadcrumb from "components/molecules/Breadcrumb";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { API_URL_apiSetting, API_URL_notificationDelete } from "constants/api";
import { apiSettingReducers } from "redux/apiSettingSlice";
import { getData, patchData } from "actions";
import { AuthContext } from "context/AuthContext";
import { toast } from "react-toastify";
import axios from "axios";

const SettingNotif = () => {
  const navigate = useNavigate();
  const [adminAccess, setAdminAccess] = useState(false);
  const { datauser } = useContext(AuthContext);
  const dispatch = useDispatch();
  // days_to_delete_notification
  const [daysToDeleteNotification, setDaysToDeleteNotification] = useState("");

  const { getApiSettingResult, addApiSettingResult } = useSelector(
    (state) => state.apiSetting
  );

  const get = useCallback(
    async (params) => {
      getData(
        API_URL_apiSetting,
        params,
        { dispatch, redux: apiSettingReducers },
        "GET_APISETTING"
      );
    },
    [dispatch]
  );

  const handleDeleteAllReadNotification = (e) => {
    e.preventDefault();
    //lakukan sesuatu
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "GET",
      url: API_URL_notificationDelete,
    })
      .then((response) => {
        toast.success(response.data.message, {
          position: "top-center",
          autoClose: true,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        fetchData();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = [
      { key: "days_to_delete_notification", value: daysToDeleteNotification },
    ];
    //edit
    patchData(
      `${API_URL_apiSetting}patch/`,
      formData,
      { dispatch, redux: apiSettingReducers },
      "ADD_APISETTING",
      () => {
        fetchData();
      }
    );
  };

  const fetchData = useCallback(() => {
    //get all of Apisetting
    const params = ``;
    get(params);
  }, [get]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (addApiSettingResult) {
      fetchData();
    }
  }, [addApiSettingResult]);

  useEffect(() => {
    //getApiSettingResult get all key & value
    if (getApiSettingResult) {
      const apiSettings = {};
      getApiSettingResult.forEach((item) => {
        apiSettings[item.key] = item.value;
      });

      setDaysToDeleteNotification(apiSettings["days_to_delete_notification"]);
    }
  }, [getApiSettingResult]);

  useEffect(() => {
    if (datauser !== "") {
      const permissionViewMenuAdmin = datauser.group_permissions.includes(
        "access_menu_admin"
      );
      if (permissionViewMenuAdmin) {
        setAdminAccess(true);
      } else {
        navigate("/dashboard/agent");
      }
    }
  }, [datauser]);

  if (!adminAccess) {
    return null;
  }

  return (
    <Container>
      <Breadcrumb
        title={"Settings"}
        excludedPaths={["setting", "administrator"]}
        group={"Superadmin"}
      />
      <div className="bg-neutral dark:bg-neutral-800 rounded overflow-hidden shadow">
        <div className="h-12 w-full grid items-center px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600 text-xs md:text-base">
          Notification settings
        </div>
        <form onSubmit={handleSubmit}>
          <div className="h-auto w-auto px-4 bg-neutral dark:bg-neutral-800 border-b border-neutral-200 dark:border-neutral-600 object-left">
            <div className="mt-4 grid grid-cols-4 gap-4">
              <div>
                <label className="text-sm md:text-sm lg:text-base items-center">
                  Delete all read notification?
                </label>
              </div>

              <div className="col-span-3 mb-2 flex items-center">
                <button
                  onClick={(e) => handleDeleteAllReadNotification(e)}
                  className="bg-red-600 hover:bg-red-500 p-1 px-2 rounded shadow-sm border text-white text-sm md:text-sm lg:text-base"
                >
                  Delete all read
                </button>
              </div>

              <div>
                <label className="text-sm md:text-sm lg:text-base items-center">
                  Days to delete notification logs{" "}
                  <span className="text-red-500">*</span>
                </label>
              </div>

              <div className="col-span-3 mb-5">
                <div className="h-auto w-full md:w-2/3 lg:w-2/3 grid items-center px-4 py-2 bg-white dark:bg-neutral-700 border border-gray-300 border-l-8 italic dark:border-neutral-600 mb-3">
                  <label className="text-sm md:text-sm lg:text-base">
                    You can enter the number of days of database logs to be
                    deleted and the history of notifications will be deleted
                    since the day specified.
                  </label>
                </div>
                <input
                  type="number"
                  name="daysToDeleteNotification"
                  id="daysToDeleteNotification"
                  value={daysToDeleteNotification}
                  onChange={(e) => setDaysToDeleteNotification(e.target.value)}
                  className="block w-full md:w-2/3 lg:w-2/3 rounded-md border border-gray-500 bg-white py-1.5 px-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-1 focus:ring-blue-400 sm:text-sm sm:leading-6 mt-3"
                />
              </div>
            </div>
          </div>
          <div className="h-12 w-full grid items-center px-4 bg-neutral-50 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
            <button
              type="submit"
              className="w-20 items-center p-1 px-3 rounded shadow-sm border text-white bg-blue-800 hover:bg-blue-700"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </Container>
  );
};

export default SettingNotif;
